/* nplus-leasing-deposit-service.js — endpoint resolution for the Lease/Finance forms.
   Two backend routes share this file: the card-deposit combined flow, and the
   no-payment inquiry flow (used when require_deposit_payment is off).
   Classic script: exposes window.nplusLeasingDeposit. No dependencies. */
(function () {
  'use strict';

  function backendBase() {
    var host = window.location.hostname;
    var isLocal = host === 'localhost' || host === '127.0.0.1';
    return (isLocal && window.__BACKEND_BASE) ? window.__BACKEND_BASE.replace(/\/$/, '') : '';
  }

  function resolveEndpoint() {
    var base = backendBase();
    return base ? base + '/create-leasing-deposit' : '/apps/nplus-deposit/create-leasing-deposit';
  }

  function resolveInquiryEndpoint() {
    var base = backendBase();
    return base ? base + '/create-leasing-inquiry' : '/apps/nplus-deposit/create-leasing-inquiry';
  }

  function post(url, payload, failureMessage) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error(body && body.error ? body.error : failureMessage);
        return body;
      });
    });
  }

  function createInquiryWithDeposit(payload) {
    return post(resolveEndpoint(), payload, 'leasing deposit request failed'); // { clientSecret, customerId, draftOrderId }
  }

  function createLeasingInquiry(payload) {
    return post(resolveInquiryEndpoint(), payload, 'leasing inquiry request failed'); // { draftOrderId, customerId }
  }

  window.nplusLeasingDeposit = {
    resolveEndpoint: resolveEndpoint,
    resolveInquiryEndpoint: resolveInquiryEndpoint,
    createInquiryWithDeposit: createInquiryWithDeposit,
    createLeasingInquiry: createLeasingInquiry
  };
})();
